
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import HRDepartmentPicker from './HRDepartmentPicker.vue';

export default HRDepartmentPicker.extend({
  name: 'EmployeeTeamDepartmentPicker',

  props: {
    employee: {
      type: Number,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      hrDepartments: 'employee/getEmployeeTeamDepartments'
    })
  },

  methods: {
    ...mapActions({
      fetchEmployeeTeamDepartments: 'employee/fetchEmployeeTeamDepartments'
    }),

    fetchHRDepartments() {
      this.clearAllErrors();
      this.loading = true;
      this.fetchEmployeeTeamDepartments(this.employee)
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessage = error.response.data.detail;
          } else {
            this.errorMessage = ErrorManager.extractApiError(error);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
